import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router";
import { deleteSite, getSiteData } from "../services/siteAPI";
import AppMenu from "../components/AppMenu";
import { Table } from "reactstrap";
import moment from "moment";
import { title } from "../config";
import SiteListTable from "./SiteListTable";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { addMultiple } from "../services/siteAPI";
import "../assets/css/Site.css";
import UserCtx from "../components/UserContext";
import { BackButton } from "../components/BackButton";
import { useToast } from "../components/ToastContext";
// import { siteActiveInactive } from "../services/constant";

export function Site() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { field, value } = useParams();
  const [pageTitle, setPageTitle] = useState();
  const [items, setItems] = useState([]);
  const [allSites, setAllSites] = useState([]);
  const [filter, setFilter] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(true);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [statusFilter, setStatusFilter] = useState("");
  const { userRole } = useContext(UserCtx);

  const getAddButton = (filter) => {
    if (!filter && userRole === 1) {
      return (
        <button
          className="fa-sharp fa-plus btn btn-outline-primary ms-2"
          onClick={() => navigate("/site/add")}
        >
          Add
        </button>
      );
    }
    return null;
  };

  const getUploadButton = (filter) => {
    if (!filter && userRole === 1) {
      return (
        <button
          className="fa-sharp fa-plus btn btn-outline-success ms-2"
          onClick={() => setShowUploadModal(true)}
        >
          Upload Excel
        </button>
      );
    }
    return null;
  };
  const getFreeSpace = (free, size) => {
    const percentageFull = ((size - free) / size) * 100;
    const roundValue = Math.round(percentageFull);
    return roundValue;
  };

  const reloadSite = async () => {
    setLoading(true);

    let records = await getSiteData(showToast);
    if (records) {
      records = records.map((item, index) => ({ ...item, originalSrNo: index + 1 }));
    }
    let filtered = records;
    let isFilter = false;

    if (value) {
      isFilter = true;
      setFilter(true);
    } else {
      setFilter(false);
    }

    if (isFilter) {
      switch (field) {
        case "version":
          filtered = records.filter(
            (record) => record[field] == value && record.active == 1
          );
          setPageTitle(`Proxy Versions ${value}`);
          break;

        case "newCmsVersion":
          filtered = records.filter(
            (record) => record.cmsActive == 1 && record?.newCmsVersion?.version == value
          );
          setPageTitle(`Client Versions ${value}`);
          break;

        case "customVersion":
          filtered = records.filter(
            (record) => record.cmsActive == 1 && record?.customVersion?.version == value
          );
          setPageTitle(`CMS Versions ${value}`);
          break;

        case "reportVersion":
          filtered = records.filter(
            (record) => record.cmsActive == 1 && record?.reportVersion?.version == value
          );
          setPageTitle(`Report Versions ${value}`);
          break;

        case "diffPM2ErrSize":
          filtered = records.filter((record) => record[field] == Number(value));
          setPageTitle("PM2 Error Logs Significant Difference");
          break;

        case "diffPM2OutSize":
          filtered = records.filter((record) => record[field] == Number(value));
          setPageTitle("PM2 Out Logs Significant Difference");
          break;

        case "adminVersion":
          filtered = records.filter(
            (record) =>
              record.cmsActive == 1 &&
              (record?.adminVersion?.version == value ||
                record?.adminVersion?.versionAdmin == value)
          );
          setPageTitle(`Admin Versions ${value}`);
          break;

        case "cmsActive":
          filtered = records.filter((record) => record[field] == Number(value));
          if (Number(value) === 1) setPageTitle("New CMS Active Sites");
          else setPageTitle(`CMS Active = ${value}`);
          break;

        case "active":
          filtered = records.filter((record) => record[field] == Number(value));
          if (Number(value) === 1) setPageTitle("Active Sites");
          else if (Number(value) === 0) setPageTitle("Inactive Sites");
          break;

        case "status":
          if (value === "error") {
            filtered = records.filter(
              (record) => record[field] === value
            );
            setPageTitle("Error Sites");
          } else if (value === "true" || value === "false") {
            const boolValue = value === "true";
            filtered = records.filter(
              (record) => String(record[field]) === value
            );
            setPageTitle(`Status: ${boolValue ? "Active" : "Inactive"} Sites`);
          }
          break;

        case "runningStatus":
          if (value === "error") {
            filtered = records.filter(
              (record) => record[field] === false
            );
            setPageTitle("Running Status Error Sites");
          } else if (value === "true" || value === "false") {
            const boolValue = value === "true";
            filtered = records.filter(
              (record) => record[field] === boolValue
            );
            setPageTitle(`Running Status: ${boolValue ? "Success" : "Error"} Sites`);
          }
          break;

        case "cms":
          if (value === "error") {
            filtered = records.filter(
              (record) => record[field] == value && record.active > 0
            );
            setPageTitle("CMS Error Sites");
          }
          break;

        case "email":
          if (value === "0") {
            filtered = records.filter((record) => record[field] === "");
            setPageTitle("Email Null Sites");
          } else if (value === "1") {
            filtered = records.filter((record) => record[field] !== "");
            setPageTitle("Contact Email Sites");
          }
          break;

        case "free":
          filtered = records.filter(
            (record) =>
              getFreeSpace(record[field], record.size) > value && record.active == 1
          );
          setPageTitle(`Memory ${value} % full Sites`);
          break;

        case "exec_mode":
          filtered = records.filter((record) => record[field] == "fork_mode");
          setPageTitle("Fork mode execution sites");
          break;

        case "node_version":
          filtered = records.filter((record) => record[field] == value);
          setPageTitle(`Node Versions ${value}`);
          break;

        case "region":
          filtered = records.filter((record) => record[field] == value);
          setPageTitle(`Region ${value}`);
          break;

        case "redisKeyCount":
          filtered = records.filter((record) => record[field] == value);
          setPageTitle(`Redis Key Count ${value}`);
          break;

        case "expiry":
          {
            const daysNum = Number(value);
            if (isNaN(daysNum)) {
              console.warn("Invalid expiry value:", value);
              filtered = [];
              setPageTitle("Invalid expiry filter");
            } else {
              filtered = records.filter((record) => {
                if (!record.sslExpiry) return false;

                const expiryMoment = moment(record.sslExpiry, moment.ISO_8601, true);
                if (!expiryMoment.isValid()) return false;

                if (expiryMoment.isBefore(moment(), "day")) return false;

                return expiryMoment.isSameOrBefore(moment().add(daysNum, "days"));
              });
              setPageTitle(`SSL Expiry Sites In ${value} Days`);
            }
          }
          break;

        case "domain-expiry":
          {
            const daysNum = Number(value);
            if (isNaN(daysNum)) {
              console.warn("Invalid domain expiry value:", value);
              filtered = [];
              setPageTitle("Invalid domain expiry filter");
            } else {
              filtered = records.filter((record) => {
                if (!record.domainExpiry) return false;

                const domainExpiryMoment = moment(record.domainExpiry, moment.ISO_8601, true);
                if (!domainExpiryMoment.isValid()) return false;

                if (domainExpiryMoment.isBefore(moment(), "day")) return false;

                return domainExpiryMoment.isSameOrBefore(moment().add(daysNum, "days"));
              });
              setPageTitle(`Domain Expiry Sites In ${value} Days`);
            }
          }
          break;

        default:
          filtered = records;
          setPageTitle("Sites");
          break;
      }
    } else {
      filtered = records;
      setPageTitle("All Sites");
    }

    setAllSites(filtered);
    setItems(filtered); 
    
    if (statusFilter) {
        if (statusFilter === "success") {
           filtered = filtered.filter((record) => record.runningStatus === true);
        } else if (statusFilter === "error") {
           filtered = filtered.filter((record) => record.runningStatus === false);
        }
    }
    if (searchText) {
         const text = searchText.toLowerCase();
         setItems(filtered);
    } else {
        setItems(filtered);
    }
    setLoading(false);
  };

  const applyFilters = (searchTextValue, statusFilterValue) => {
    let result = allSites;
    if (statusFilterValue === "success") {
      result = result.filter((record) => record.runningStatus === true);
    } else if (statusFilterValue === "error") {
      result = result.filter((record) => record.runningStatus === false);
    }

    if (searchTextValue.length) {
      const text = searchTextValue.toLowerCase();
      const statusMap = {
        true: "Active",
        false: "Inactive",
      };
      const runningStatusMap = {
        true: "SUCCESS",
        false: "ERROR",
      };

      result = result.filter((record) => {
        const nameMatch = record.name?.toLowerCase().startsWith(text);
        const linkMatch = record.link?.toLowerCase().startsWith(text);

        let hostnameMatch = false;
        if (record.link) {
          try {
            const hostname = new URL(record.link).hostname.toLowerCase();
            hostnameMatch = hostname.startsWith(text);
          } catch (err) {
            hostnameMatch = false;
          }
        }

        const statusString =
          typeof record.status === "boolean"
            ? statusMap[record.status]
            : (record.status || "").toString();
        const statusMatch = statusString.toLowerCase().startsWith(text);

        const runningStatusString =
          typeof record.runningStatus === "boolean"
            ? runningStatusMap[record.runningStatus]
            : (record.runningStatus || "").toString();
        const runningStatusMatch = runningStatusString
          .toLowerCase()
          .startsWith(text);

        return (
          nameMatch ||
          linkMatch ||
          hostnameMatch ||
          statusMatch ||
          runningStatusMatch
        );
      });
    }

    setItems(result);
  };

  const doDelete = async (_id) => {
    try {
      const result = await deleteSite(_id, showToast);

      if (result?.result === "success") {
        showToast(result?.msg ?? "Site deleted successfully!", "success");
      } else {
        showToast(result?.msg ?? "Failed to delete site", "error");
      }

      reloadSite();
    } catch (error) {
      console.error(error);
      showToast("An error occurred while deleting the site", "error");
    }
  };

  const doUpgrade = (link) => {
    const upgradeUrl = `https://core.${link}/check-update`;
    return upgradeUrl;
  };
  const doHistory = (id, currentPage) => {
    navigate(`/state/${id}?page=${currentPage}`);
  };
  const doEdit = (id) => {
    navigate(`/site/edit/${id}`);
  };

  const onSearchChange = (e) => {
    const value = e?.target?.value || "";
    setSearchText(value);
    applyFilters(value, statusFilter);
  };

  const handleStatusFilterChange = (e) => {
    const selected = e.target.value;
    setStatusFilter(selected);
    applyFilters(searchText, selected);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".site-filter-wrapper")) {
        document.getElementById("statusSelect")?.classList.remove("open");
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    reloadSite();
    setPageTitle("Sites");
  }, [field, value]);
  return (
    <div className="site-container">
      <div className="px-2 sticky-header">
        <h3 className="m-0 p-2">{title} | {pageTitle}</h3>
        <AppMenu />
      </div>
      <div className="p-0 px-2 m-0">
        <div className="site-toolbar px-2">
          <div className="site-toolbar-left">
            <BackButton icon="←" />
            <input
              value={searchText}
              onChange={onSearchChange}
              placeholder="Search Site Name"
              type="search"
              className="site-search"
            />

            <div className="site-filter-wrapper">
              <div
                className={`site-filter-display ${statusFilter ? "active" : ""}`}
                onClick={() =>
                  document.getElementById("statusSelect").classList.toggle("open")
                }
              >
                <span>{statusFilter ? statusFilter.toUpperCase() : "All"}</span>

                {statusFilter && (
                  <span
                    className="filter-clear"
                    onClick={(e) => {
                      e.stopPropagation();
                      setStatusFilter("");
                      setItems(allSites);
                      document.getElementById("statusSelect").classList.remove("open");
                    }}
                  >
                    ×
                  </span>
                )}

                <span className="filter-arrow">▾</span>
              </div>

              <div id="statusSelect" className="site-filter-dropdown">
                <div
                  onClick={() => {
                    handleStatusFilterChange({ target: { value: "" } });
                    document.getElementById("statusSelect").classList.remove("open");
                  }}
                >
                  All
                </div>
                <div
                  onClick={() => {
                    handleStatusFilterChange({ target: { value: "success" } });
                    document.getElementById("statusSelect").classList.remove("open");
                  }}
                >
                  SUCCESS
                </div>
                <div
                  onClick={() => {
                    handleStatusFilterChange({ target: { value: "error" } });
                    document.getElementById("statusSelect").classList.remove("open");
                  }}
                >
                  ERROR
                </div>
              </div>
            </div>


            <div className="site-btn-group">
              {getAddButton(filter, navigate)}
              {getUploadButton(filter, setShowUploadModal)}
            </div>
          </div>

          <span className="site-total">
            Total: {items.length}
          </span>
        </div>

        {/* <hr className="p-0 my-2" /> */}
      </div>
      {
        loading ?
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "75vh" }}>
            <div className="spinner-border">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div> :
          items?.length > 0 ? (
            <SiteListTable
              items={items}
              doDelete={doDelete}
              doEdit={doEdit}
              doHistory={doHistory}
              doUpgrade={doUpgrade}
              userRole={userRole}
            />
          )
            :
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "75vh" }}>
              {/* <div className="spinner-border"> */}
              <span className="">No records found...</span>
              {/* </div> */}
            </div>}
      <Modal isOpen={showUploadModal} toggle={() => setShowUploadModal(false)} centered>
        <ModalHeader toggle={() => setShowUploadModal(false)}>
          Upload Excel File
        </ModalHeader>
        <ModalBody>
          <input
            type="file"
            accept=".xlsx, .xls"
            onChange={(e) => setSelectedFile(e.target.files[0])}
            className="form-control"
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowUploadModal(false)}>
            Cancel
          </Button>
          <Button
            color="primary"
            disabled={!selectedFile || uploading}
            onClick={async () => {
              if (!selectedFile) return alert("Please select a file first!");
              const formData = new FormData();
              formData.append("file", selectedFile);
              //console.log("selectedFile", selectedFile)

              try {
                setUploading(true);
                const response = await addMultiple(formData, showToast);
                alert(`${response.message || "Upload successful!"}`);
                setShowUploadModal(false);
                setSelectedFile(null);
                reloadSite(); // refresh list
              } catch (error) {
                console.error("Upload error:", error);
                alert("Upload failed. Please check console.");
              } finally {
                setUploading(false);
              }
            }}
          >
            {uploading ? "Uploading..." : "Upload"}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

// const getStatus = (status) => {
//   let statusSite = siteActiveInactive.find(
//     (item) => item.value === Number(status)
//   );
//   if (statusSite) {
//     return statusSite.name;
//   } else {
//     return "";
//   }
// };

// const getFreeSpace = (free, size) => {
//   const percentageFull = ((size - free) / size) * 100;
//   const roundValue = Math.round(percentageFull);
//   return roundValue;
// };

// const getAddButton = (filter, navigate) => {
//   if (!filter) {
//     return (
//       <button
//         className="fa-sharp fa-plus btn btn-outline-primary"
//         onClick={() => {
//           navigate("/site/add");
//         }}
//         variant="contained"
//       > Add </button>
//     );
//   }
// };
// function SiteList({ items, doDelete, doEdit, doHistory, doUpgrade }) {
//   const [localItems, setlocalItems] = useState([...items]);
//   const [toggleSorting, setToggleSorting] = useState(0);
//   const [dynamicStyles, setDynamicStyles] = useState();

//   useEffect(() => {
//     const styles = `.cursor-pointer
//         { cursor: pointer;}`;
//     setDynamicStyles(styles);
//     setlocalItems(items);
//   }, [items]);

//   const sortTable = (field) => {
//     let sortedData = [];

//     if (toggleSorting === 1) {
//       sortedData = [...localItems].sort((a, b) => a[field] > b[field] ? 1 : -1);
//       setToggleSorting(0);
//     } else {
//       sortedData = [...localItems].sort((a, b) => b[field] > a[field] ? 1 : -1);
//       setToggleSorting(1);
//     }
//     setlocalItems(sortedData);
//   }

//   // const sortTable = (field) => {
//   //   let sortedData = [];
//   //   if (toggleSorting === 1) {
//   //     sortedData = [...localItems].
//   //     sort((a, b) => {
//   //       if (a[field] > b[field]) {
//   //         return -1;
//   //       } else if (a[field] < b[field]) {
//   //         return 1;
//   //       } else {
//   //         return 0;
//   //       }
//   //     });
//   //     setToggleSorting(0);
//   //   } else {
//   //     sortedData = [...localItems].sort((a, b) => {
//   //       if (a[field] < b[field]) {
//   //         return -1;
//   //       } else if (a[field] > b[field]) {
//   //         return 1;
//   //       } else {
//   //         return 0;
//   //       }
//   //     });
//   //     setToggleSorting(1);
//   //   }
//   //   setlocalItems(sortedData);
//   // };

//   return (
//     <div className="p-0 m-0 px-2">
//       <style>{dynamicStyles}</style>
//       <Table className="table table-hover" responsive hover>
//         <thead>
//           <tr>
//             <th onClick={() => sortTable("name")} className="cursor-pointer">Name</th>
//             <th>
//               <span onClick={() => sortTable("cms")} className="cursor-pointer">CMS</span> |
//               <span onClick={() => sortTable("status")} className="cursor-pointer">Proxy</span>
//             </th>
//             <th onClick={() => sortTable("exDate")} className="cursor-pointer">Cert. Exp</th>
//             <th onClick={() => sortTable("domain")} className="cursor-pointer">Domain</th>
//             <th onClick={() => sortTable("exec_mode")} className="cursor-pointer">Ex.mode</th>
//             <th onClick={() => sortTable(getFreeSpace('free', 'size'))} className="cursor-pointer">Memory</th>
//             <th onClick={() => sortTable("osUptime")} className="cursor-pointer">OS Uptime</th>
//             <th onClick={() => sortTable("nodeUptime")} className="cursor-pointer">Proxy Uptime</th>
//             <th>
//               <span onClick={() => sortTable("databases")} className="cursor-pointer">DBs</span> |
//               <span onClick={() => sortTable("redisKeyCount")} className="cursor-pointer"> RedisKey </span>
//             </th>
//             <th>
//               <span onClick={() => sortTable("active")} className="cursor-pointer">P.Active </span> |
//               <span onClick={() => sortTable("cmsActive")} className="cursor-pointer"> CMS </span>
//             </th>
//             <th>Proxy V.</th>
//             <th>CMS V.</th>
//             <th>Admin V.</th>
//             <th onClick={() => sortTable("node_version")} className="cursor-pointer">Node V.</th>
//             <th>I.Type</th>
//             <th>R.Link</th>
//             <th>
//               <span onClick={() => sortTable("item?.siteUserDetails?.activeUserCount")} className="cursor-pointer">A.User</span>|
//               <span onClick={() => sortTable("item?.siteUserDetails?.currentSessionCount")} className="cursor-pointer"> Session </span>
//             </th>
//             <th>
//               <span onClick={() => sortTable("item?.siteUserDetails?.activeUserCount")} className="cursor-pointer">NoSigin</span> |
//               <span onClick={() => sortTable("item?.siteUserDetails?.currentSessionCount")} className="cursor-pointer"> Sometime </span>
//             </th>
//             <th onClick={() => sortTable("region")} className="cursor-pointer">Region</th>
//             <th onClick={() => sortTable("diffPM2ErrSize")} className="cursor-pointer">Diff. Error | Out </th>
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {localItems.map((item) => (
//             <tr key={item._id}>
//               <td>{item.name}</td>
//               <td> {item.cms}|{item.status}</td>
//               <td>{moment(item.exDate).format("DD/MM/YYYY")}</td>
//               <td>
//                 <a href={`https://${item.domain}`} target="_blank">{item.domain}</a>
//               </td>
//               <td>{item.exec_mode}</td>
//               <td>
//                 {`${item.free
//                   ? getFreeSpace(item.free, item.size) +
//                   "%" +
//                   " (" +
//                   (item.size / 1073741824).toFixed(0) +
//                   "GB)"
//                   : " "
//                   }`}
//               </td>
//               <td>
//                 {item.osUptime
//                   ? Math.round(item.osUptime / (60 * 60 * 24)).toFixed(0)
//                   : " -"}{" "}
//                 Days
//               </td>
//               <td>
//                 {item.nodeUptime
//                   ? Math.round(item.nodeUptime / (60 * 60)).toFixed(0)
//                   : " -"}{" "}
//                 Hrs
//               </td>

//               <td>{item.databases ? item.databases : "-"} | {item.redisKeyCount ? item.redisKeyCount : "-"}</td>
//               <td>{item.active} | {item?.cmsActive}</td>
//               <th>{item?.version} | {item?.date}</th>
//               <th>{item?.newCmsVersion?.version} | {item?.newCmsVersion?.date}</th>
//               <th>{item?.adminVersion?.version} | {item?.adminVersion?.date}</th>
//               <td>{item.node_version ? item.node_version : " "}</td>
//               <td>{item.instituteType}</td>
//               <td>{item.redirectLink ? item.redirectLink : "-"}</td>
//               <td>
//                 {item?.siteUserDetails?.activeUserCount ? item?.siteUserDetails?.activeUserCount : "-"} |
//                 {item?.siteUserDetails?.currentSessionCount ? item?.siteUserDetails?.currentSessionCount : "-"}
//               </td>
//               <td>
//                 {item?.siteUserDetails?.notLoggedInUsers ? item?.siteUserDetails?.notLoggedInUsers : "-"} |
//                 {item?.siteUserDetails?.loginCounLessThanFive ? item?.siteUserDetails?.loginCounLessThanFive : "-"}
//               </td>
//               <td>{item.region ? item.region : "-"}</td>
//               <td>{(item.diffPM2ErrSize / (1024 ** 2)).toFixed(2)}| {(item.diffPM2OutSize / (1024 ** 2)).toFixed(2)} MB</td>
//               <td className="">
//                 <div className="dropdown float-end pe-2">
//                   <a
//                     href="#"
//                     role="button"
//                     data-bs-toggle="dropdown"
//                     aria-expanded="false"
//                   >
//                     <i className="fa-solid fa-bars"></i>
//                   </a>
//                   <ul className="dropdown-menu p-2">
//                     <a href={doUpgrade(item.domain)} target={"_blank"}>
//                       <i
//                         className="fa-solid fa-cloud-arrow-up btn btn-dark m-2 "
//                         aria-hidden="true"
//                       ></i>
//                     </a>
//                     <i
//                       className="fa-solid fa-clock-rotate-left btn btn-warning m-2 "
//                       onClick={() => doHistory(item._id)}
//                     ></i>
//                     <i
//                       className="fas fa-edit btn btn-primary m-2 "
//                       onClick={() => doEdit(item._id)}
//                       aria-hidden="true"
//                     ></i>
//                     <i
//                       className="fa-solid fa-trash-can btn btn-danger m-2"
//                       onClick={() => doDelete(item._id)}
//                       aria-hidden="true"
//                     ></i>
//                   </ul>
//                 </div>
//               </td>
//               <th></th>
//             </tr>
//           ))}
//         </tbody>
//       </Table>
//     </div>
//   );
// }
